import { MuiModal, Text } from '@pinchenterprisesnpm/friday-ui'
import { InviteUpshiftersContent } from '@src/features/shift-post-v2/steps/invite-upshifters-step/components/invite-upshifters-section/components/invite-upshifters-content/invite-upshifters-content'

const { Header, Content } = MuiModal

interface IInvitationSummaryModalProps {
  isOpen: boolean
  closeModal: () => void
}

export const InvitationSummaryModal = ({
  isOpen,
  closeModal,
}: IInvitationSummaryModalProps) => {
  return (
    <MuiModal
      isOpen={isOpen}
      closeModal={closeModal}
      fullWidth
      maxWidth="md"
      sx={{
        '& .MuiDialogContent-root': {
          height: '600px',
          position: 'relative',
        },
      }}
    >
      <Header title="Invitation Summary" />

      <Content>
        <Text my="sm">
          Send personalised invites exclusively to Upshifters you`ve previously
          worked with. They`ll have priority access for the next 12 hours.
        </Text>

        <InviteUpshiftersContent />
      </Content>
    </MuiModal>
  )
}
